module.exports = __webpack_public_path__ + "img/logo2.525ac3e9.png";